import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import AutoSizer from 'react-virtualized-auto-sizer';

// LOCAL VARIABLES
import { MOBILE_ROW_HEIGHT } from '../variables';

// HELPERS
import { useListData } from 'helpers/getListData';

// LOCAL COMPONENTS
import SortedVirtualized from './layout/SortedVirtualized';

export default function MobileListSorted({
  autoSizeHeight = true, //
  className,
  defaultTitle,
  sortParam,
  sortedResult,
  toolbar,
  ...props
}) {
  // HOOKS / PROPS
  const {
    result: data = [], //
    preferences: { filters } = {}
  } = {...(useListData() || {}), ...props};

  // MEMOS
  const groupedData = useMemo(
    () =>
      sortedResult ||
      data.reduce((acc, cur) => {
        const sortKey = sortParam || filters?.sort;
        const title = cur[sortKey] || defaultTitle;
        if (!!title) {
          const child = acc.find(obj => obj.title === title);
          if (!child)
            acc.push({
              title,
              data: [cur]
            });
          else child.data.push(cur);
        }
        return acc;
      }, []),
    [data, defaultTitle, filters.sort, sortParam, sortedResult]
  );

  return (
    <div className={clsx('flex-grow-1 large', className)}>
      <AutoSizer disableWidth disableHeight={!autoSizeHeight}>
        {({ height }) => (
          <SortedVirtualized
            {...props} //
            height={height}
            numLoaded={groupedData.length}
            result={groupedData}
            rowHeight={MOBILE_ROW_HEIGHT}
          />
        )}
      </AutoSizer>
    </div>
  );
}
